import { render, staticRenderFns } from "./ViewDefaultHeader.vue?vue&type=template&id=6e2d451c&scoped=true&"
import script from "./ViewDefaultHeader.vue?vue&type=script&lang=js&"
export * from "./ViewDefaultHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewDefaultHeader.vue?vue&type=style&index=0&id=6e2d451c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d451c",
  null
  
)

export default component.exports